import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../lib/auth";
import { Menu, X, LogOut } from "lucide-react";

export default function Navbar() {
    const { user, logout } = useAuth();
    const [open, setOpen] = React.useState(false);
    const nav = useNavigate();

    const dashLink =
        user?.role === "admin"
            ? "/dashboard/admin"
            : user?.role === "club"
                ? "/dashboard/club"
                : "/dashboard/sponsor";

    return (
        <header className="sticky top-0 z-40 border-b border-zinc-900 bg-[#09090b]/85 backdrop-blur-xl">
            <div className="max-w-7xl mx-auto px-6 lg:px-8 h-16 flex items-center justify-between">
                <Link to="/" data-testid="navbar-logo" className="flex items-center gap-2">
                    <img
                        src="/brand/sponsormania-logo.png"
                        alt="Sponsormania.fr"
                        className="h-9 w-auto object-contain"
                    />
                </Link>

                <nav className="hidden md:flex items-center gap-8 text-sm uppercase tracking-widest font-semibold text-zinc-300">
                    <Link to="/clubs" data-testid="nav-clubs" className="hover:text-orange-500 transition-colors">
                        Clubs
                    </Link>
                    <Link to="/concept" data-testid="nav-concept" className="hover:text-orange-500 transition-colors">
                        Concept
                    </Link>
                    <Link to="/impact" data-testid="nav-impact" className="hover:text-orange-500 transition-colors">
                        Impact
                    </Link>
                    <Link to="/realisations" data-testid="nav-realisations" className="hover:text-orange-500 transition-colors">
                        Réalisations
                    </Link>
                </nav>

                <div className="hidden md:flex items-center gap-3">
                    {user ? (
                        <>
                            <Link to={dashLink} data-testid="nav-dashboard" className="btn-ghost py-2 px-5 text-xs">
                                Mon espace
                            </Link>
                            <button
                                onClick={async () => {
                                    await logout();
                                    nav("/");
                                }}
                                data-testid="nav-logout"
                                className="text-zinc-400 hover:text-orange-500 transition-colors"
                                title="Déconnexion"
                            >
                                <LogOut size={18} />
                            </button>
                        </>
                    ) : (
                        <>
                            <Link to="/login" data-testid="nav-login" className="text-zinc-300 text-xs uppercase tracking-widest hover:text-orange-500">
                                Se connecter
                            </Link>
                            <Link to="/register" data-testid="nav-register" className="btn-primary py-2 px-5 text-xs">
                                S'inscrire
                            </Link>
                        </>
                    )}
                </div>

                <button
                    className="md:hidden text-zinc-300"
                    onClick={() => setOpen((o) => !o)}
                    data-testid="nav-mobile-toggle"
                >
                    {open ? <X /> : <Menu />}
                </button>
            </div>

            {open && (
                <div className="md:hidden border-t border-zinc-900 bg-[#09090b] px-6 py-4 flex flex-col gap-4 text-sm uppercase tracking-widest">
                    <Link onClick={() => setOpen(false)} to="/clubs">
                        Clubs
                    </Link>
                    <Link onClick={() => setOpen(false)} to="/concept">
                        Concept
                    </Link>
                    <Link onClick={() => setOpen(false)} to="/impact">
                        Impact
                    </Link>
                    <Link onClick={() => setOpen(false)} to="/realisations">
                        Réalisations
                    </Link>
                    {user ? (
                        <>
                            <Link onClick={() => setOpen(false)} to={dashLink}>
                                Mon espace
                            </Link>
                            <button
                                onClick={async () => {
                                    await logout();
                                    setOpen(false);
                                    nav("/");
                                }}
                                className="text-left text-orange-500"
                            >
                                Déconnexion
                            </button>
                        </>
                    ) : (
                        <>
                            <Link onClick={() => setOpen(false)} to="/login">
                                Se connecter
                            </Link>
                            <Link onClick={() => setOpen(false)} to="/register" className="text-orange-500">
                                S'inscrire
                            </Link>
                        </>
                    )}
                </div>
            )}
        </header>
    );
}
